import { FC, useCallback, useEffect, useState } from 'react';
import SalesCallsList from './SalesCallsList';
import axiosInstance from '../../../../utils/axios';
import { URLS } from '../../../../utils/constants/urls';
import { createDropdownData } from '../../../../utils/validators/HelperFunctions';

const SalesListTab: FC = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [assignees, setAssignees] = useState<any[]>([]);
  const [viewMode, setViewMode] = useState<'table' | 'card'>('table');

  const fetchAssignees = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get(URLS.getReportingUsers);

      setAssignees(createDropdownData(data, ['id', 'name']));
    } catch (error: any) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchAssignees();
  }, [fetchAssignees]);

  return (
    <SalesCallsList
      tabValue={tabValue}
      onTabChange={setTabValue}
      assignees={assignees}
      viewMode={viewMode}
      onViewModeChange={setViewMode}
    />
  );
};

export default SalesListTab;
